import { render, staticRenderFns } from "./CompanyInfoModules.vue?vue&type=template&id=4513bc3e&"
import script from "./CompanyInfoModules.vue?vue&type=script&lang=ts&"
export * from "./CompanyInfoModules.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4513bc3e')) {
      api.createRecord('4513bc3e', component.options)
    } else {
      api.reload('4513bc3e', component.options)
    }
    module.hot.accept("./CompanyInfoModules.vue?vue&type=template&id=4513bc3e&", function () {
      api.rerender('4513bc3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/company/CompanyInfoModules.vue"
export default component.exports